import {call, put} from "redux-saga/effects";
import { setCartReportListing , setLoading, setError} from "redux/slices/cartReportingSlice";
import { getCartReportListService } from "../requests/cartReportListingService";

export function* handleGetCartReportlist(action) {

  try {
    yield put(setLoading(true))
    const response = yield call(() => getCartReportListService(action.payload))
    yield put(setCartReportListing(response.data))

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}
